import React, { FC } from "react";
import { QuestionProps } from "../../../pages/form";
import { Maybe } from "graphql/jsutils/Maybe";
import { Core_LocalTimeMsg } from "../../../src/generated/graphql";
import { LocalTimeInput } from "./components/local-time-input";

export const LocalTimeQuestion: FC<QuestionProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const localTimeQuestion = question?.localTime;
  const localTimeValue = answer?.value?.localTime?.value;

  function answerQuestion(value: Maybe<Core_LocalTimeMsg> | undefined) {
    onAnswer({
      localTime: { value },
    });
  }

  return (
    <div>
      <LocalTimeInput value={localTimeValue} onChange={answerQuestion} />
    </div>
  );
};
